export const BASE_URL = 'https://api.nasa.gov/planetary/apod'